import { render, staticRenderFns } from "./transferTicket.vue?vue&type=template&id=246b58c8"
import script from "./transferTicket.vue?vue&type=script&lang=js"
export * from "./transferTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports